<ng-template #content>
	<div class="app-modal min-h-0 max-h-full grid gap-4" [class]="widthClasses()">
		<div class="grid gap-10 min-h-0 max-h-full">
			<div class="grid gap-4 min-h-0 max-h-full">
				@if (showHeader()) {
					<div class="header flex items-start">
						@if (title()) {
							<div class="header-title-block flex flex-col gap-1">
								@if (subtitle()) {
									<div class="subtitle">{{ subtitle() }}</div>
								}
								<h4 class="title" [id]="titleId()">{{ title() }}</h4>
							</div>
						}
						@if (closeVisible()) {
							<div class="close-icon ml-auto">
								<i
									class="pi pi-times-circle"
									role="button"
									tabindex="0"
									aria-label="Uždaryti"
									(click)="handleClose()"
									(keydown.enter)="handleClose()"
									(keydown.space)="$event.preventDefault(); handleClose()"
								></i>
							</div>
						}
					</div>
				}
				<div class="grid overflow-y-auto">
					<ng-content></ng-content>
				</div>
			</div>
			<div class="flex items-center justify-end gap-2" [class.justify-center]="centerButton() || !showHeader()">
				<ng-content select="[footer]"></ng-content>
			</div>
		</div>
	</div>
</ng-template>

@if (standaloneDialog()) {
	<p-dialog
		[visible]="true"
		[modal]="true"
		[closable]="canDismiss()"
		[showHeader]="false"
		[dismissableMask]="canDismiss()"
		[closeOnEscape]="false"
		[ariaLabelledBy]="dialogLabelledBy()"
		(visibleChange)="onDialogVisibleChange($event)"
	>
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</p-dialog>
} @else {
	<ng-container *ngTemplateOutlet="content"></ng-container>
}
